import { useEffect, useContext, useRef } from 'react';
import { MapContext } from '../contexts/MapContext';
import { mapModes } from '../constants/map';
import { OFFSET_INCREMENT_FEET, OFFSET_MAX_FEET } from '../constants/fields';

const useOffset = (map) => {
  const {
    fields: { updateFieldSection },
    mapState: { activeField, mapMode, setContext },
  } = useContext(MapContext);

  const updateFieldSectionRef = useRef();
  updateFieldSectionRef.current = updateFieldSection;
  const activeFieldRef = useRef();
  activeFieldRef.current = activeField;

  useEffect(() => {
    if (mapMode !== mapModes.OFFSET) return undefined;
    map.keyboard.disable();
    const onKeydown = (e) => {
      // inputs on the page allow adjusting numbers or moving the cursor with arrow keys
      // if one of those is focused, don't adjust the field offset
      if (e.target.localName === 'input') {
        return;
      }
      const field = activeFieldRef.current;
      const updateField = updateFieldSectionRef.current;
      const offset = {
        X: field.offsetX,
        Y: field.offsetY,
      };
      if (e.key === 'ArrowLeft') {
        offset.X = (field.offsetX || 0) - OFFSET_INCREMENT_FEET;
      }
      if (e.key === 'ArrowRight') {
        offset.X = (field.offsetX || 0) + OFFSET_INCREMENT_FEET;
      }
      if (e.key === 'ArrowDown') {
        offset.Y = (field.offsetY || 0) - OFFSET_INCREMENT_FEET;
      }
      if (e.key === 'ArrowUp') {
        offset.Y = (field.offsetY || 0) + OFFSET_INCREMENT_FEET;
      }
      if ([offset.X, offset.Y].some((v) => Math.abs(v) > OFFSET_MAX_FEET)) {
        return;
      }
      updateField(field.id, {
        offsetX: offset.X,
        offsetY: offset.Y,
      });
      setContext({ hasOffset: true });
    };
    window.addEventListener('keydown', onKeydown);

    return () => {
      window.removeEventListener('keydown', onKeydown);
      map.keyboard.enable();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapMode]);
};

export default useOffset;
